import {GlobalVariables} from "../GlobalVariables";

export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			if( button.classList.contains('btn-share') || button.classList.contains('gform_button') ){
				return;
			}

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="50" height="54" viewBox="0 0 50 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7803 49.6981L23.5981 53.5714L50 26.7857L23.5981 0L19.7803 3.87236L39.6649 24.046L0 24.046L0 29.5239L39.6649 29.5239L19.7803 49.6981Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-download') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-gallery') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if( button.classList.contains('btn-lang') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-contact') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5283 7.24528H7.55547L5.64906 9.38943L5.58566 9.46189L5.50415 9.40981C4.33811 8.66943 3.33057 7.66189 2.59019 6.49585L2.53811 6.41434L2.61057 6.35094L4.75472 4.44453V1.4717C4.75472 0.661132 4.09359 0 3.28302 0H1.4717C0.661132 0 0 0.661132 0 1.4717C0.00679245 7.27019 4.72981 11.9932 10.5283 12C11.3389 12 12 11.3389 12 10.5283V8.71698C12 7.90642 11.3389 7.24528 10.5283 7.24528ZM1.98566 5.38868L1.92226 5.24604C1.39472 4.0483 1.12981 2.77811 1.13208 1.4717C1.13208 1.28377 1.28377 1.13208 1.4717 1.13208H3.28302C3.47094 1.13208 3.62264 1.28377 3.62264 1.4717V3.93283L3.58415 3.96679L2.10113 5.28453L1.98566 5.38868ZM10.8679 10.5283C10.8679 10.7162 10.7162 10.8679 10.5283 10.8679H10.5147C9.21057 10.8679 7.94491 10.603 6.7517 10.0777L6.60906 10.0143L6.71321 9.89887L8.03094 8.41585L8.06491 8.37736H10.526C10.714 8.37736 10.8657 8.52906 10.8657 8.71698V10.5283H10.8679Z" fill="#083523"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-search') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31326C0 1.93263 1.93263 0 4.31326 0C6.69389 0 8.62652 1.93263 8.62652 4.31326C8.62652 5.31058 8.28719 6.22947 7.71786 6.9603L9.84323 9.08568C10.0523 9.29471 10.0523 9.63419 9.84323 9.84323C9.63419 10.0523 9.29471 10.0523 9.08568 9.84323L6.96031 7.71785C6.22948 8.28719 5.31058 8.62652 4.31326 8.62652C1.93263 8.62652 0 6.69389 0 4.31326ZM4.31326 1.07144C2.52417 1.07144 1.07144 2.52417 1.07144 4.31326C1.07144 6.10235 2.52417 7.55508 4.31326 7.55508C6.10235 7.55508 7.55508 6.10235 7.55508 4.31326C7.55508 2.52417 6.10235 1.07144 4.31326 1.07144Z" fill="#083523"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-map') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 48">
\t<path class="cls-1" d="M21,44a1,1,0,0,1-.71-.3l-12-12.3a18.72,18.72,0,0,1,0-26,17.73,17.73,0,0,1,25.48,0h0a18.72,18.72,0,0,1,0,26l-12,12.3A1,1,0,0,1,21,44ZM21,2A15.73,15.73,0,0,0,9.69,6.79,16.71,16.71,0,0,0,9.69,30L21,41.57,32.31,30a16.71,16.71,0,0,0,0-23.21h0A15.73,15.73,0,0,0,21,2Z"/><path class="cls-1" d="M21,27a9,9,0,1,1,9-9A9,9,0,0,1,21,27Zm0-16a7,7,0,1,0,7,7A7,7,0,0,0,21,11Z"/><path class="cls-1" d="M21,48c-.86,0-21-.06-21-5,0-4,13.11-4.77,17.12-4.93l.08,2c-10,.39-14.87,2.13-15.21,3,.44,1,7.17,3,19,3s18.57-2,19-3c-.34-.75-5.16-2.49-15.21-2.88l.08-2c4,.16,17.12,1,17.12,4.93C42,47.94,21.86,48,21,48Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( button.classList.contains('btn-list') ){

				const element = document.createElement("span");
				element.innerHTML = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
\t<rect x="156" y="434" width="299" height="45"/>
\t<rect x="55" y="434" width="56" height="45"/>
\t<rect x="156" y="334" width="299" height="45"/>
\t<rect x="55" y="334" width="56" height="45"/>
\t<rect x="55" y="234" width="56" height="45"/>
\t<rect x="156" y="234" width="299" height="45"/>
\t<rect x="55" y="134" width="56" height="45"/>
\t<rect x="156" y="134" width="299" height="45"/>
\t<rect x="55" y="34" width="56" height="45"/>
\t<rect x="156" y="34" width="299" height="45"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);

			} else if ( ! button.classList.contains('btn-simple') ) {

				const element = document.createElement("span");
				element.classList.add('dot');
				button.appendChild(element);

			}

			if( button.classList.contains('js-btn-anchor')){
				button.addEventListener( 'click', (e) => {
					e.preventDefault();
					GlobalVariables.smoother.scrollTo(button.hash, true);
				});
			}

		});

	}

}
